<i18n src="@/locales/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/pallets/package_group_card.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>
<template>
  <div :class="['md:flex justify-between h-[10rem]', rounded_class]">
    <div
      class="
        md:flex
        justify-between
        leading-tight
        min-w-[80%]
        md:min-w-[90%]
      "
    >
      <div class="flex flex-col pl-2 pt-2">
        <h3 class="text-lg font-medium truncate">
            {{ package_group.pg_code }}
        </h3>
        
        <div class="text-base grow text-gray-600">
          {{ getProducerLabel(package_group) }}
        </div>
        <div v-if="package_group.thermo_code" class="text-gray-500 pt-3">
          <i class="fa-solid fa-temperature-list"></i>
          <span class="space-icon" />
          {{ package_group.thermo_code }}
        </div>
      </div>
      <div class="text-grey-darker text-sm">
        <div>
          {{ getQuantityLabel(package_group) }} {{ package_group.variety_name }}
        </div>
        <div v-if="package_group.brand_name">
          {{ $t("model.package_group.exporter_process_brand_id") }}
          {{ package_group.brand_name }}
        </div>
        <div v-if="package_group.category_name">
          {{
            $t(
              "model.package_group.exporter_process_crop_category_id_abbreviation"
            )
          }}
          {{
            package_group.category_name
          }}
        </div>
      </div>
    </div>
    <div class="flex flex-row md:flex-col justify-start">
      <div>
        <button
          @click.prevent="goToMove(package_group)"
          :class="[pallet_action_btn_class]"
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          title="Tooltip on right"
        >
          <i class="fa-solid fa-grip-dots"></i>
          <span class="tooltiptext">{{ $t("labels.move_link") }}</span>
        </button>
      </div>
      <div>
        <button
          @click.prevent="goToClone(package_group)"
          :class="[pallet_action_btn_class]"
        >
          <span class="tooltiptext">{{ $t("labels.clone_link") }}</span>
          <i class="fa-solid fa-copy"></i>
        </button>
      </div>
      <div>
        <button
          @click.prevent="goToEdit(package_group)"
          :class="[pallet_action_btn_class]"
        >
          <i class="fa-solid fa-pencil"></i>
          <span class="tooltiptext">{{ $t("labels.edit_link") }}</span>
        </button>
      </div>
      <div>
        <destroy-pallet-btn
          v-if="package_group"
          :btn_class="pallet_destroy_action_btn_class"
          :package_group="package_group"
          @update:packages-groups="remove($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DestroyPalletBtn from "@/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/pallets/Destroy.vue";

export default {
  props: {
    package_group: {
      type: Object,
      required: true,
    },
    rounded_class: {
      type: String,
      default: "",
    },
  },
  components: {
    DestroyPalletBtn,
  },
  computed: {
    action_btn_class: function () {
      return "inline-flex justify-center py-2 px-4 border shadow-sm text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2";
    },
    agro_exporter_process_id: function () {
      return this.$router.currentRoute._value.params.agro_exporter_process_id;
    },
    container_id: function () {
      return this.$router.currentRoute._value.params.container_id;
    },
    pallet_action_btn_class: function () {
      return `${this.action_btn_class} border-gray-700 text-gray-700 hover:text-white hover:bg-gray-700 focus:ring-gray-500 w-[2rem] h-[2rem] tooltip`;
    },
    pallet_destroy_action_btn_class: function () {
      return `${this.action_btn_class} bg-red-700 border border-red-700 text-white hover:bg-red-700 focus:ring-red-500 w-[2rem] h-[2rem]`;
    },
  },
  methods: {
    getProducerLabel: function (package_group) {
      return package_group.packages
        .map((package_item) => this.getProducerLabelByPackage(package_item))
        .join(", ");
    },
    getProducerLabelByPackage: function (package_item) {
      let org_name = null;
      if (package_item.organization) org_name = package_item.organization.name;
      if (package_item.producer) {
        let producer_name = package_item.producer.name;
        if (org_name) return `${producer_name} (${org_name})`;
        return producer_name;
      } else if (org_name) {
        return org_name;
      }
      return "";
    },
    getQuantityLabel: function (package_group) {
      return package_group.total_packages_with_labels_data
        .map((package_type) =>
          this.$t("model.package_group.package_quantity", package_type)
        )
        .join(", ");
    },
    goToClone: function (package_group) {
      this.$router.push({
        name: "ae_production_uniq_final_packing_list_clone_package_group_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
          package_group_id: package_group.id,
        },
      });
    },
    goToEdit: function (package_group) {
      this.$router.push({
        name: "ae_production_uniq_final_packing_list_edit_package_group_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
          package_group_id: package_group.id,
        },
      });
    },
    goToMove: function (package_group) {
      this.$router.push({
        name: "ae_production_uniq_final_packing_list_move_package_group_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
          package_group_id: package_group.id,
        },
      });
    },
    remove: function (package_group) {
      this.$emit("destroy", package_group);
    },
  },
};
</script>

<style scoped>
.tooltip {
  position: relative;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: min-content;
  background-color: black;
  color: #fff;
  text-align: right;
  border-radius: 6px;
  padding: 5px 10px;
  margin-top: 5px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: -5px;
  right: 105%;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
